export const CLICKUP_FEEDBACK_FORMS = {
  nl: 'https://forms.clickup.com/2182389/f/22k7n-22452/BOAYG6R1A4JMI8NPGL',
};
